// extracted by mini-css-extract-plugin
export default {"logoVideo":"LogoVideo_logoVideo__AGU9Z"};